import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Switch, Route, withRouter, useLocation } from 'react-router-dom';
import sessionStorage from '@avalara/bat-apps-shared/helpers/sessionStorage';
import TierSelector from '../../components/buy-flow/tier-selector';
import ThankYou from '../../components/buy-flow/thank-you';
import PageNotFound from '../../components/page-not-found';
import { getConnectors, getMarketingDataFromUrl, blockPageFromIndexing } from '../../lib/side-effects';
import { checkIsAuthenticated } from '../../lib/helpers';
import { selectConnector } from '../../lib/side-effects/connectors';
import { setActiveFlow } from '../../store/system';
import { setTrialExtension } from '../../store/buy-flow';
import { getSystemErrorMessaging } from '../../lib/side-effects/error';
import { selectState } from '../../selectors';
import SignupContainer from '../signup';
import CybersourcePaymentPage from '../../components/cybersource-payment';
let TOGGLE = true;
const BuyFlow = () => {
    const dispatch = useDispatch();
    const location = useLocation();
    const { account: { accountId, supportedConnector }, data: { connectors: { data: connectors } }, } = useSelector(selectState);
    const [connectorId, setConnectorId] = useState();
    const [trialExpired, setTrialExpired] = useState();
    const [showDirectBuy, setShowDirectBuy] = useState(false);
    useEffect(() => {
        dispatch(blockPageFromIndexing());
        if (!checkIsAuthenticated()) {
            dispatch(setActiveFlow('avatax-direct-buy'));
            setShowDirectBuy(true);
        }
        else {
            setShowDirectBuy(false);
            dispatch(setActiveFlow('avatax-buy'));
        }
    }, []);
    useEffect(() => {
        if (accountId == null)
            return;
        dispatch(setActiveFlow('avatax-buy'));
        dispatch(getConnectors());
        dispatch(getMarketingDataFromUrl());
    }, [accountId]);
    useEffect(() => {
        const searchParams = new URLSearchParams(location.search);
        setConnectorId(searchParams.get('connectorId') || sessionStorage.get('connectorId') || null);
        setTrialExpired(searchParams.get('trialExpired'));
    }, [location.search]);
    useEffect(() => {
        if (trialExpired)
            dispatch(setTrialExtension());
    }, [trialExpired]);
    useEffect(() => {
        if (!connectorId || !connectors.length)
            return;
        dispatch(selectConnector(connectorId));
        sessionStorage.set('connectorId', connectorId);
    }, [connectorId, connectors]);
    if (accountId === null || showDirectBuy)
        return React.createElement(SignupContainer, null);
    if (!supportedConnector && TOGGLE) {
        TOGGLE = false;
        dispatch(getSystemErrorMessaging({ errorCode: 'unsupportedConnector' }));
    }
    return (React.createElement(Switch, null,
        React.createElement(Route, { exact: true, path: '/buy', component: TierSelector }),
        React.createElement(Route, { path: '/buy/payment' },
            React.createElement(CybersourcePaymentPage, { paymentView: 'default' })),
        React.createElement(Route, { path: '/buy/success', component: ThankYou }),
        React.createElement(Route, { component: PageNotFound })));
};
export default withRouter(BuyFlow);
